var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramRenovations40(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.9278989,8.72727273 L4.53409091,8.72727273 C5.49085091,8.72727273 1.84326068,8.72727273 1.84326068,8.72727273 C1.05329318,8.59594781 0.263320909,7.73635251 0.263320909,6.87675722 L0.263320909,6.16042781 C0.263320909,4.76478289 0.263320909,1.71919059 0.263320909,1.71919059 C0.263320909,0.859595294 1.05329318,0 1.84326068,0 L10.9278989,0 C13.6927923,0 15.2727273,1.54010695 15.2727273,4.62032086 C15.2727273,7.18716578 13.6927923,8.59594781 10.9278989,8.72727273 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.36363636,8.72727273 L4.13271273,8.72727273 C5.05854545,8.72727273 1.52886545,8.72727273 1.52886545,8.72727273 C0.764430545,8.59594781 0,7.73635251 0,6.87675722 L0,6.16042781 C0,4.76478289 0,1.71919059 0,1.71919059 C0,0.859595294 0.764430545,0 1.52886545,0 L4.36363636,0 L4.36363636,8.72727273 Z",
    id: "path-3"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-5",
    points: "0 0 3.03896104 0 3.03896104 4.36363636 0 4.36363636"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-7",
    points: "2.47933884 8.72727273 0 0 2.97520661 0 5.45454545 8.72727273"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Repair40",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Search40"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bounding-Box",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-21",
    transform: "translate(8.000000, 12.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(8.727273, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    fill: "#FFFFFF",
    mask: "url(#mask-2)",
    points: "-2.12304273 -2.56684492 17.6590909 -2.56684492 17.6590909 11.2941176 -2.12304273 11.2941176"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M19.5789471,8.72727273 L13.072966,8.72727273 C14.0465082,8.72727273 10.3349281,8.72727273 10.3349281,8.72727273 C9.53110017,8.59594781 8.72727273,7.73635251 8.72727273,6.87675722 L8.72727273,6.16042781 C8.72727273,4.76478289 8.72727273,1.71918905 8.72727273,1.71918905 C8.72727273,0.859594781 9.53110017,0 10.3349281,0 L19.5789471,0 C22.3923422,0 24,1.54010695 24,4.62032086 C24,7.18716578 22.3923422,8.59594781 19.5789471,8.72727273 Z",
    id: "Stroke-4",
    stroke: "#4F4C4D"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(8.727273, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-6"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-5",
    fill: "#FFCC00",
    mask: "url(#mask-4)",
    points: "-2.18181818 -2.56684492 6.54545455 -2.56684492 6.54545455 11.2941176 -2.18181818 11.2941176"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M13.0909091,8.72727273 L12.8599868,8.72727273 C13.7858182,8.72727273 10.2561382,8.72727273 10.2561382,8.72727273 C9.49170545,8.59594781 8.72727273,7.73635251 8.72727273,6.87675722 L8.72727273,6.16042781 C8.72727273,4.76478289 8.72727273,1.71918905 8.72727273,1.71918905 C8.72727273,0.859594781 9.49170545,0 10.2561382,0 L13.0909091,0 L13.0909091,8.72727273 Z",
    id: "Stroke-8",
    stroke: "#4F4C4D"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(5.454545, 2.181818)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-10"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-9",
    fill: "#FFFFFF",
    mask: "url(#mask-6)",
    points: "-2.33766234 -2.18181818 5.37662338 -2.18181818 5.37662338 6.54545455 -2.33766234 6.54545455"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-16",
    transform: "translate(0.000000, 1.090909)",
    stroke: "#4F4C4D"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-12",
    points: "5.36842105 4.95867769 8.54066986 4.95867769 8.54066986 0 5.36842105 0"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 2.47933884,
    x2: 5.36842105,
    y2: 2.47933884,
    id: "Stroke-13",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-14",
    strokeLinejoin: "round",
    points: "13.1770335 7.78512397 13.1770335 10.5123967 16.1052632 10.5123967"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14.6411483,
    y1: 16.3636364,
    x2: 18.5454545,
    y2: 16.3636364,
    id: "Stroke-15",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-19",
    transform: "translate(15.272727, 8.727273)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-8",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-18"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-17",
    fill: "#FFFFFF",
    mask: "url(#mask-8)",
    points: "-2.47933884 -2.42424242 7.9338843 -2.42424242 7.9338843 11.1515152 -2.47933884 11.1515152"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-20",
    stroke: "#4F4C4D",
    points: "17.7520661 17.4545455 15.2727273 8.72727273 18.2479339 8.72727273 20.7272727 17.4545455"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramRenovations40);
export default __webpack_public_path__ + "static/media/pictogramRenovations40.0851414dec0e428d93c2f6990dee0930.svg";
export { ForwardRef as ReactComponent };